import axios from "axios";
import { API_BASE_URL } from "../config";

// const formatDate = (date) => {
//   const day = String(date.getDate()).padStart(2, "0");
//   const month = String(date.getMonth() + 1).padStart(2, "0"); // Month is 0-indexed
//   const year = date.getFullYear();
//   return `${day}-${month}-${year}`;
// };

const districts = [
  "Ariyalur",
  "Chengalpattu",
  "Chennai",
  "Coimbatore",
  "Cuddalore",
  "Dharmapuri",
  "Dindigul",
  "Erode",
  "Kallakurichi",
  "Kancheepuram",
  "Karur",
  "Krishnagiri",
  "Madurai",
  "Nagapattinam",
  "Kanyakumari",
  "Namakkal",
  "Perambalur",
  "Pudukottai",
  "Ramanathapuram",
  "Ranipet",
  "Salem",
  "Sivagangai",
  "Tenkasi",
  "Thanjavur",
  "Theni",
  "Thoothukudi",
  "Tiruchirappalli",
  "Tirunelveli",
  "Tirupattur",
  "Tiruppur",
  "Tiruvallur",
  "Tiruvannamalai",
  "Tiruvarur",
  "Vellore",
  "Viluppuram",
  "Virudhunagar",
];

export const tamilnaduDistrictOptions = districts.map((district) => ({
  value: district,
  label: district,
}));

export const getCountries = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/countries`
    );
    return response.data.data.map((country) => ({
      value: country.id,
      label: country.name,
    }));
  } catch (error) {
    console.error("Error fetching countries:", error);
    return []; // Return empty array if there's an error
  }
};

export const getStates = async (country_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/states?filter={"country_id":${country_id}}`
    );
    return response.data.data.map((state) => ({
      value: state.id,
      label: state.name,
    }));
  } catch (error) {
    console.error("Error fetching countries:", error);
    return []; // Return empty array if there's an error
  }
};

export const getCities = async (state_id) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/cities?filter={"state_id":${state_id}}`
    );
    return response.data.data.map((city) => ({
      value: city.id,
      label: city.name,
    }));
  } catch (error) {
    console.error("Error fetching countries:", error);
    return []; // Return empty array if there's an error
  }
};

export const getBranches = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/branch_details`
    );
    return response.data.data.map((option) => ({
      value: option.id,
      label: option.branchName,
    }));
  } catch (error) {
    console.error("Error fetching Branches:", error);
    return []; // Return empty array if there's an error
  }
};

export const getRoles = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/roles?notInclude={"roleName":["superadmin"]}`
    );
    return response.data.data.map((option) => ({
      value: option.id,
      label: option.roleName,
    }));
  } catch (error) {
    console.error("Error fetching Data:", error);
    return []; // Return empty array if there's an error
  }
};

export const getFieldOfficersOptions = async (branchId = null) => {
  try {
    let url = `${API_BASE_URL}/api/getFieldOfficersOptions`;
    if (branchId) {
      url += `?branchId=${branchId}`;
    }
    const response = await axios.get(url);
    return response.data.data.map((option) => ({
      value: option.id,
      label: option.username,
    }));
  } catch (error) {
    console.error("Error fetching Data:", error);
    return []; // Return empty array if there's an error
  }
};

export const getCustomerUniqueIds = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/personal_details?fields=customerUniqueId,mobileNumber&notInclude={"customerUniqueId":["Null"]}`
    );
    return response.data.data.map((option) => ({
      value: option.customerUniqueId,
      label: option.customerUniqueId,
    }));
  } catch (error) {
    console.error("Error fetching customerUniqueIds:", error);
    return []; // Return empty array if there's an error
  }
};

export const getCustomerOptions = async (branchId = null) => {
  try {
    // Construct the URL with necessary fields.
    //
    // Only customers an admin has approved on the Customers screen may be the
    // subject of a new loan / FD / member application, so filter on
    // `adminverification`. Beware the two look-alike columns documented in
    // models/personal_details.js: `adminverification` (with the "i") is CUSTOMER
    // verification — this one; `adminverfication` (no "i") is LOAN approval.
    // `data_operator_status` is the data-operator queue and is not it either.
    //
    // Filtered here rather than in getModelData: that endpoint is generic and
    // shared by ~20 screens, including the Customers page, which must keep
    // listing pending customers because that is where they get approved.
    let url = `${API_BASE_URL}/api/getModelData/personal_details?fields=id,customerUniqueId,name,mobileNumber,branchId`
      + `&filter=${encodeURIComponent(JSON.stringify({ adminverification: "verified" }))}`;

    // Add branchId filter query parameter if a branchId is provided
    // This pushes the filtering to the backend (database) instead of client-side
    if (branchId) {
      url += `&branchId=${branchId}`;
    }

    // Note: Removed notInclude={"customerUniqueId":["Null"]} to allow showing customers even if ID looks null/invalid
    // as per user request "customerId shows that null it is possible"

    const response = await axios.get(url);

    let data = response.data.data;

    console.log(`Fetched ${data?.length || 0} customers${branchId ? ` for branch ${branchId}` : ''}`);

    // Map with safety checks for null values
    return (data || []).map((option) => ({
      value: option.id,
      label: option.customerUniqueId || "No ID", // Handle null/empty customerUniqueId
      name: option.name || "Unknown Name",       // Handle null/empty name
      mobileNumber: option.mobileNumber,
      branchId: option.branchId,
    }));
  } catch (error) {
    console.error("Error fetching Data:", error);
    return []; // Return empty array if there's an error
  }
};

export const getAccountNumbers = async (accountType) => {
  try {
    let url = `${API_BASE_URL}/api/getModelData/account_details?fields=accountNumber&includeDepth=1&relationshipType=childToParent`;
    if (accountType) {
      url += `&filter={"accountType":"${accountType}"}`;
    }

    const response = await axios.get(url);
    return response.data.data.map((option) => ({
      value: option.accountNumber,
      label:
        option.accountNumber +
        "--" +
        option.fk_account_details_belongsTo_personal_details_customerUniqueId
          .name,
    }));
  } catch (error) {
    console.error("Error fetching accountNumber:", error);
    return []; // Return empty array if there's an error
  }
};

export const getCustomerUniqueIdByAccountNumber = async (accountNumber) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/account_details?fields=customerUniqueId&filter={"accountNumber":"${accountNumber}"}`
    );
    return response.data.data[0].customerUniqueId;
  } catch (error) {
    console.error("Error fetching customerUniqueId:", error);
    return null; // Return empty array if there's an error
  }
};

export const getBusinessCategoriesOptions = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/business_categories`
    );
    return response.data.data.map((category) => ({
      value: category.id,
      label: category.business_category,
    }));
  } catch (error) {
    console.error("Error fetching business categories:", error);
    return []; // Return empty array if there's an error
  }
};

export const getNatureOfBusinessOptions = async (businessCategoryId) => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/nature_of_business?filter={"businessCategoryId":${businessCategoryId}}`
    );
    return response.data.data.map((option) => ({
      value: option.id,
      label: option.natureOfBusiness,
    }));
  } catch (error) {
    console.error("Error fetching natureOfBusiness:", error);
    return []; // Return empty array if there's an error
  }
};

export const getFundingAgencies = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/funding_agencies`
    );
    // The FPO's own money accumulated four names over time — OWN FUNDING 1,
    // OWN FUNDING 2, OWN FUND 3, OWN FUNDING 4 — alongside OWN FUND itself. All
    // five are funding_type 'equity'; only OWN FUND is offered, so an operator
    // choosing "our own money" has exactly one option and new lending stops
    // fragmenting across five accounts.
    //
    // The retired rows are NOT deleted: 5,186 existing loans reference them, and
    // each keeps repaying the Loans Outstanding account it was disbursed from.
    // ActionButtons.jsx maps a stored variant onto OWN FUND for display.
    return response.data.data
      .filter(
        (option) =>
          option.funding_type !== "equity" ||
          String(option.agencyName || "").trim() === "OWN FUND"
      )
      .map((option) => ({
        value: option.id,
        label: option.agencyName,
      }));
  } catch (error) {
    console.error("Error fetching Data:", error);
    return []; // Return empty array if there's an error
  }
};

export const getStaffDetails = async () => {
  try {
    const response = await axios.get(
      `${API_BASE_URL}/api/getModelData/staff_details?fields=staffId,name,roleId,designation`
    );

    const staffData = response.data?.data || []; // Ensure data exists

    // Filter to include only staff with roleId 4 (Field Officers)
    return staffData
      .filter((staff) => staff.roleId === 3)
      .map((staff) => ({
        label: staff.name,
        value: staff.staffId,
      }));
  } catch (error) {
    console.error("Error fetching staff for field officers:", error);
    return []; // Return an empty array in case of error
  }
};

export const initialPersonalDetails = {
  fieldOfficerId: null,
  name: null,
  gender: null,
  dob: null,
  age: null,
  mobileNumber: null,
  altMobileNumber: null,
  maritalStatus: null,
  fatherName: null,
  spouseName: null,
  permanentDoorNo: 0,
  permanentStreetAddress: null,
  permanentVillage: null,
  permanentCity: null,
  permanentDistrict: null,
  permanentState: null,
  permanentPostalCode: null,
  sameAsPermanentAddress: false,
  currentDoorNumber: 0,
  currentStreetAddress: null,
  currentVillage: null,
  currentCity: null,
  currentState: null,
  currentPostalCode: null,
  citizenship: "Indian",
  customerProfileImage: null,
  customerSignatureImage: null,
  adminverification: "pending",
};

// formFieldsConfig.js
export const personalDetailsFields = async (branchId = null) => {
  try {
    const fieldOfficerOptions = await getFieldOfficersOptions(branchId);
    return [
      {
        label: "Assigned to Field Officer",
        type: "select",
        name: "fieldOfficerId",
        options: fieldOfficerOptions,
        placeholder: "Select Field Officer",
        required: true,
      },
      { label: "Name", type: "text", name: "name", required: true },
      {
        label: "Gender",
        type: "select",
        name: "gender",
        options: [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
          { value: "Other", label: "Other" },
        ],
        placeholder: "Select Gender",
        required: true,
      },
      { label: "Date of Birth", type: "datepicker", name: "dob", required: true },
      {
        label: "Age",
        type: "number",
        name: "age",
        readOnly: true,
        required: true,
      },
      {
        label: "Mobile Number",
        type: "number",
        name: "mobileNumber",
        required: true,
      },
      {
        label: "Alternate Mobile Number",
        type: "number",
        name: "altMobileNumber",
        required: false,
      },
      {
        label: "Marital Status",
        type: "select",
        name: "maritalStatus",
        options: [
          { value: "Married", label: "Married" },
          { value: "Unmarried", label: "Unmarried" },
          { value: "Others", label: "Others" },
        ],
        placeholder: "Select Marital Status",
        required: true,
      },
      {
        label: "Father's Name",
        type: "text",
        name: "fatherName",
        required: false,
      },
      {
        label: "Spouse's Name",
        type: "text",
        name: "spouseName",
        required: false,
      },
      // ── Permanent Address ───────────────────────────────────────────
      {
        label: "Permanent Door Number",
        type: "text",
        name: "permanentDoorNo",
        required: false,
      },
      {
        label: "Permanent Street Address",
        type: "text",
        name: "permanentStreetAddress",
        required: true,
      },
      {
        label: "Permanent Village",
        type: "text",
        name: "permanentVillage",
        required: false,
      },
      {
        label: "Permanent City",
        type: "text",
        name: "permanentCity",
        required: false,
      },
      {
        label: "Permanent District",
        type: "text",
        name: "permanentDistrict",
        required: false,
      },
      {
        label: "Permanent State",
        type: "text",
        name: "permanentState",
        required: false,
      },
      {
        label: "Permanent Postal Code",
        type: "number",
        name: "permanentPostalCode",
        required: true,
      },
      {
        label: "Same as Permanent Address",
        type: "checkbox",
        name: "sameAsPermanentAddress",
        required: false,
      },
      // ── Current Address ──────────────────────────────────────────────
      {
        label: "Current Door Number",
        type: "text",
        name: "currentDoorNumber",
        required: false,
      },
      {
        label: "Current Street Address",
        type: "text",
        name: "currentStreetAddress",
        required: false,
      },
      {
        label: "Current Village",
        type: "text",
        name: "currentVillage",
        required: false,
      },
      {
        label: "Current City",
        type: "text",
        name: "currentCity",
        required: false,
      },
      {
        label: "Current State",
        type: "text",
        name: "currentState",
        required: false,
      },
      {
        label: "Current Postal Code",
        type: "number",
        name: "currentPostalCode",
        required: false,
      },
      {
        label: "Citizenship",
        type: "text",
        name: "citizenship",
        readOnly: true,
        required: true,
      },
      // Captured HERE, at customer creation — this is the only screen where they
      // can be uploaded. The Business Loan wizard shows the same two fields
      // read-only (memberPersonalDetailsFields below), so a customer created
      // without them leaves the loan screen displaying "No Document" with no way
      // to fix it.
      //
      // Enforced on Add only; see validationSchema.js. 10 of the 12 existing
      // customers have neither image, and a blanket rule would make every one of
      // them uneditable — opening one to correct a phone number would demand two
      // uploads first.
      {
        label: "Customer Profile Image",
        type: "file",
        name: "customerProfileImage",
        required: true,
      },
      {
        label: "Customer Signature Image",
        type: "file",
        name: "customerSignatureImage",
        required: true,
      },
    ];
  } catch (error) {
    console.error("Error fetching personal details fields:", error);
    return [];
  }
};

export const initialVerificationDetails = {
  aadharNo: null,
  aadharFrontImage: null,
  aadharBackImage: null,
  panNo: null,
  idProof: null,
  idProofNo: null,
  idProofFrontImage: null,
  idProofBackImage: null,
  addressProof: null,
  addressProofNo: null,
  addressProofFrontImage: null,
  addressProofBackImage: null,
};

export const verificationDetailsFields = [
  { label: "Aadhar No", type: "number", name: "aadharNo", required: true },
  {
    label: "Aadhar Front Image",
    type: "file",
    name: "aadharFrontImage",
    required: false,
  },
  {
    label: "Aadhar Back Image",
    type: "file",
    name: "aadharBackImage",
    required: false,
  },
  { label: "PAN No", type: "text", name: "panNo", required: false },
  {
    label: "ID Proof",
    type: "select",
    name: "idProof",
    options: [
      { value: "Voter", label: "Voter" },
      { value: "Driving Licence", label: "Driving Licence" },
      { value: "Ration", label: "Ration" },
      { value: "Passport", label: "Passport" },
      { value: "Aadhar", label: "Aadhar" },
      { value: "Pan", label: "PanCard" },

    ],
    placeholder: "Select ID Proof",
    required: false,
  },
  { label: "ID Proof No", type: "text", name: "idProofNo", required: false },
  {
    label: "ID Proof Front Image",
    type: "file",
    name: "idProofFrontImage",
    required: false,
  },
  {
    label: "ID Proof Back Image",
    type: "file",
    name: "idProofBackImage",
    required: false,
  },
  {
    label: "Address Proof",
    type: "select",
    name: "addressProof",
    options: [
      { value: "Electricity Bill", label: "Electricity Bill" },
      { value: "Gas Bill", label: "Gas Bill" },
      { value: "Smart Card", label: "Smart Card" },
      { value: "Smart Card", label: "Smart Card" },
      { value: "Aadhar", label: "Aadhar" },
    ],
    placeholder: "Select Address Proof",
    required: false,
  },
  {
    label: "Address Proof No",
    type: "text",
    name: "addressProofNo",
    required: false,
  },
  {
    label: "Address Proof Front Image",
    type: "file",
    name: "addressProofFrontImage",
    required: false,
  },
  {
    label: "Address Proof Back Image",
    type: "file",
    name: "addressProofBackImage",
    required: false,
  },
];

export const initialNomineeDetails = {
  name: null,
  fatherName: null,
  gender: null,
  dob: null,
  mobileNumber: null,
  alMobileNumber: 0,
  relationship: null,
  address: null,
  aadharNo: null,
  idProof: null,
  idProofNo: null,
  idProofFrontImage: null,
  idProofBackImage: null,
};

export const nomineeDetailsFields = [
  { label: "Name", type: "text", name: "name", required: false },
  { label: "Father Name", type: "text", name: "fatherName", required: false },
  {
    label: "Gender",
    type: "select",
    name: "gender",
    options: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "other", label: "other" },
    ],
    placeholder: "Select Gender",
    required: false,
  },
  { label: "Date of Birth", type: "date", name: "dob", required: false },
  {
    label: "Mobile Number",
    type: "number",
    name: "mobileNumber",
    required: false,
  },
  {
    label: "Alt Mobile Number",
    type: "number",
    name: "altMobileNumber",
    required: false,
  },
  {
    label: "Relationship",
    type: "select",
    name: "relationship",
    options: [
      { value: "spouse", label: "spouse" },
      { value: "father", label: "father" },
      { value: "mother", label: "mother" },
      { value: "son", label: "son" },
      { value: "daughter", label: "daughter" },
      { value: "grand-mother", label: "grand-mother" },
      { value: "grand-father", label: "grand-father" },
      { value: "other", label: "other" },
    ],
    placeholder: "Select Relationship",
    required: false,
  },
  { label: "Address", type: "text", name: "address", required: false },
  { label: "Aadhar No", type: "text", name: "aadharNo", required: false },
  {
    label: "ID Proof",
    type: "select",
    name: "idProof",
    options: [
      { value: "Voter", label: "Voter" },
      { value: "Driving Licence", label: "Driving Licence" },
      { value: "Ration", label: "Ration" },
      { value: "Passport", label: "Passport" },
      { value: "Aadhar", label: "Aadhar" },
      { value: "Pan", label: "PanCard" },

    ],
    placeholder: "Select ID Proof",
    required: false,
  },
  { label: "ID Proof No", type: "text", name: "idProofNo", required: false },
  {
    label: "ID Proof Front Image",
    type: "file",
    name: "idProofFrontImage",
    required: false,
  },
  {
    label: "ID Proof Back Image",
    type: "file",
    name: "idProofBackImage",
    required: false,
  },
];

export const initialOtherDetails = {
  qualification: null,
  religion: null,
  caste: null,
  bloodGroup: null,
  language: null,
  emailId: null,
  profession: null,
  monthlyIncome: 0,
  annualIncome: 0,
  otherIncome: 0,
};

export const otherDetailsFields = [
  {
    label: "Qualification",
    type: "select",
    name: "qualification",
    options: [
      { value: "Degree", label: "Degree" },
      { value: "Master Degree", label: "Master Degree" },
      { value: "Diploma", label: "Diploma" },
      { value: "School", label: "School" },
      { value: "Other", label: "Other" },
    ],
    placeholder: "Select Qualification",
    required: false,
  },
  {
    label: "Religion",
    type: "select",
    name: "religion",
    options: [
      { value: "Hindu", label: "Hindu" },
      { value: "Muslim", label: "Muslim" },
      { value: "Christian", label: "Christian" },
      { value: "Other", label: "Other" },
    ],
    placeholder: "Select Religion",
    required: false,
  },
  {
    label: "Caste",
    type: "select",
    name: "caste",
    options: [
      { value: "FC", label: "FC" },
      { value: "BC", label: "BC" },
      { value: "MBC", label: "MBC" },
      { value: "SC", label: "SC" },
      { value: "DNC", label: "DNC" },
      { value: "Others", label: "Others" },
    ],
    placeholder: "Select Caste",
    required: false,
  },
  {
    label: "Blood Group",
    type: "select",
    name: "bloodGroup",
    options: [
      { value: "A+", label: "A+" },
      { value: "A-", label: "A-" },
      { value: "B+", label: "B+" },
      { value: "B-", label: "B-" },
      { value: "AB+", label: "AB+" },
      { value: "AB-", label: "AB-" },
      { value: "O+", label: "O+" },
      { value: "O-", label: "O-" }
    ],
    placeholder: "Select Blood Group",
    required: false,
  },
  {
    label: "Language",
    type: "text",
    name: "language",
    required: false,
  },
  { label: "Email Id", type: "text", name: "emailId", required: false },
  { label: "Profession", type: "text", name: "profession", required: false },
  {
    label: "Monthly Income",
    type: "number",
    name: "monthlyIncome",
    required: false,
  },
  {
    label: "Annual Income",
    type: "number",
    name: "annualIncome",
    required: false,
  },
  {
    label: "Other Income",
    type: "number",
    name: "otherIncome",
    required: false,
  },
];

export const initialBankDetails = {
  accountNumber: null,
  accountHolderName: null,
  bankName: null,
  bankBranchName: null,
  accountType: null,
};

export const bankDetailsFields = [
  {
    label: "Account Number",
    type: "number",
    name: "accountNumber",
    required: false,
  },
  {
    label: "Account Holder Name",
    type: "text",
    name: "accountHolderName",
    required: false,
  },
  { label: "IFSC Code", type: "text", name: "ifscCode", required: false },
  { label: "Bank Name", type: "text", name: "bankName", required: false },
  {
    label: "Bank Branch Name",
    type: "text",
    name: "bankBranchName",
    required: false,
  },
  { label: "Account Type", type: "text", name: "accountType", required: false },
];

export const handleFileChange = (e, name, setFilePreviews) => {
  const file = e.target.files[0];
  if (file) {
    const previewUrl = URL.createObjectURL(file);

    // Store both the file object and the preview URL
    setFilePreviews((prev) => ({
      ...prev,
      [name]: { file, previewUrl },
    }));
  }
};

export const initialBranchDetails = {
  branchName: null,
  branchUniqueId: null,
  country: null,
  state: null,
  district: null,
  city: null,
  address: null,
  pincode: null,
  village: null,
  startDate: null,
  payment_qr: null,
};

export const getBranchDetailsFields = async (country1, state1) => {
  try {
    // Fetch countries and states
    const countries = await getCountries();

    // Fetch states based on country selection
    let states = [];
    let districts = [];
    if (country1) {
      states = await getStates(country1); // Assuming getStates returns an array of states for the selected country
    }
    if (state1) {
      districts = await getCities(state1);
    }

    // Return dynamically populated fields
    return [
      {
        label: "Branch Name",
        type: "text",
        name: "branchName",
        required: true,
      },
      {
        label: "Branch Unique Id",
        type: "text",
        name: "branchUniqueId",
        readOnly: true,
        required: false,
        // Generated by the server on save (addDetailsWithImages.js:117 mints
        // "JL" + the branch series). In Add it is a box that can never hold
        // anything; in Edit it holds a value nobody may change. Shown only where
        // it means something — View.
        //
        // `readOnly` stays: the two answer different questions — whether it can
        // be typed into, versus whether it should be on screen at all.
        viewOnly: true,
      },
      {
        label: "Country",
        type: "select",
        name: "country",
        required: true,
        options: countries,
      },
      {
        label: "State",
        type: "select",
        name: "state",
        required: true,
        options: states,
      },
      {
        label: "District",
        type: "select",
        name: "district",
        required: true,
        options: districts,
      },
      {
        label: "City",
        type: "text",
        name: "city",
        required: false,
      },
      {
        label: "Address",
        type: "text",
        name: "address",
        required: true,
      },
      {
        label: "Pincode",
        type: "number",
        name: "pincode",
        required: true,
      },
      {
        label: "Village",
        type: "text",
        name: "village",
        required: true,
      },
      {
        label: "Start Date",
        type: "date",
        name: "startDate",
        required: false,
      },
      {
        label: "Payment QR",
        type: "file",
        name: "payment_qr",
        required: false,
      },
    ];
  } catch (error) {
    console.error("Error fetching branch details fields:", error);
    return []; // Return empty array if there's an error
  }
};

export const initialCenterDetails = {
  branchId: null,
  centerName: null,
  centerUniqueId: null,
  address: null,
  pincode: null,
  phoneNo: null,
  landMark: null,
};

export const getCenterDetailsFields = async () => {
  try {
    // Fetch countries and states
    const branches = await getBranches();
    const fieldOfficerOptions = await getStaffDetails();

    // Return dynamically populated fields
    return [
      {
        label: "Branch Name",
        type: "select",
        name: "branchId",
        required: true,
        options: branches,
      },
      {
        label: "Field Officer Name",
        type: "select",
        name: "fieldofficerId", // This field will store the staffId of the selected Field Officer
        required: true,
        options: fieldOfficerOptions,
      },
      {
        label: "Center Name",
        type: "text",
        name: "centerName",
        required: true,
      },
      {
        label: "Center Unique Id",
        type: "text",
        name: "centerUniqueId",
        readOnly: true,
        required: false,
      },
      {
        label: "Address",
        type: "text",
        name: "address",
        required: true,
      },
      {
        label: "Pincode",
        type: "number",
        name: "pincode",
        required: true,
      },
      {
        label: "Phone No",
        type: "number",
        name: "phoneNo",
        required: false,
      },
      {
        label: "Land Mark",
        type: "text",
        name: "landMark",
        required: true,
      },
    ];
  } catch (error) {
    console.error("Error fetching center details fields:", error);
    return []; // Return empty array if there's an error
  }
};

export const initialRoleDetails = {
  roleName: null,
};

export const roleDetailsFields = [
  {
    label: "Role Name",
    type: "text",
    name: "roleName",
    required: true,
  },
];

// export const initialStaffDetails = {
//   staffImage: null,
//   username: null,
//   password: null,
// };

// export const getStaffDetailsFields = [
//   {
//     label: "Staff Image",
//     type: "file",
//     name: "staffImage",
//     required: true,
//   },
//   {
//     label: "Username",
//     type: "text",
//     name: "username",
//     required: true,
//   },
//   {
//     label: "Password",
//     type: "password",
//     name: "password",
//     required: true,
//   },
// ];

export const initialStaffDetails = {
  staffImage: null,
  staffId: null,
  name: null,
  phoneNo: null,
  emailId: null,
  username: null,
  password: null,
  dob: null,
  doj: null,
  gender: null,
  designation: null,
  address: null,
  officeOrField: null,
  emergencyContact1: null,
  relationshipWithStaff1: null,
  emergencyContactName1: null,
  emergencyContact2: null,
  relationshipWithStaff2: null,
  emergencyContactName2: null,
  altPhoneNumber: 0,
  state: null,
  city: null,
  education: null,
  roleId: null,
  branchId: null,
};

export const getStaffDetailsFields = async (state1, userBranchId, roleName) => {
  try {
    // Fetch states based on country selection
    let states = [];
    let cities = [];
    states = await getStates(101);
    if (state1) {
      cities = await getCities(state1);
    }
    const branches = await getBranches();

    // Filter branches based on user role and branchId
    let filteredBranches = branches;
    if (roleName !== "superadmin" && userBranchId) {
      filteredBranches = branches.filter(branch => branch.value === userBranchId);
    }

    const roles = await getRoles();

    // Return dynamically populated fields
    return [
      {
        label: "Staff Image",
        type: "file",
        name: "staffImage",
        required: true,
      },
      {
        label: "Staff Id",
        type: "text",
        name: "staffId",
        required: false,
        readOnly: true,
        // Generated by the server on save (addDetailsWithImages.js:105 takes the
        // next number from the staffId series). In Add it is a box that can never
        // hold anything; in Edit it holds a value nobody may change. Shown only
        // where it means something — View. Same reasoning as branchUniqueId.
        viewOnly: true,
      },
      {
        label: "Name",
        type: "text",
        name: "name",
        required: true,
      },
      {
        label: "Username",
        type: "text",
        name: "username",
        required: true,
      },
      {
        label: "Password",
        type: "password",
        name: "password",
        required: true,
      },
      {
        label: "Designation",
        type: "text",
        name: "designation",
        required: true,
      },
      {
        label: "Role",
        type: "select",
        name: "roleId",
        required: true,
        options: roles,
      },
      {
        label: "Branch",
        type: "select",
        name: "branchId",
        required: true,
        options: filteredBranches,
        readOnly: roleName !== "superadmin",
      },
      {
        label: "Phone Number",
        type: "number",
        name: "phoneNo",
        required: true,
      },
      {
        label: "Email Id",
        type: "text",
        name: "emailId",
        required: false,
      },
      {
        label: "Date of Birth",
        type: "date",
        name: "dob",
        required: true,
      },
      {
        label: "Date of Joining",
        type: "date",
        name: "doj",
        required: true,
      },
      {
        label: "Gender",
        type: "select",
        name: "gender",
        options: [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
          { value: "Other", label: "Other" },
        ],
        required: true,
      },
      {
        label: "Address",
        type: "text",
        name: "address",
        required: true,
      },
      {
        label: "City",
        type: "select",
        name: "city",
        required: true,
        options: cities,
      },
      {
        label: "State",
        type: "select",
        name: "state",
        required: true,
        options: states,
      },
      {
        label: "Office/Field",
        type: "text",
        name: "officeOrField",
        required: false,
      },
      {
        label: "Emergency Contact",
        type: "number",
        name: "emergencyContact1",
        required: false,
      },
      {
        label: "Relationship with Staff",
        type: "text",
        name: "relationshipWithStaff1",
        required: false,
      },
      {
        label: "Emergency Contact Name",
        type: "text",
        name: "emergencyContactName1",
        required: false,
      },
      {
        label: "Emergency Contact",
        type: "number",
        name: "emergencyContact2",
        required: false,
      },
      {
        label: "Relationship with Staff",
        type: "text",
        name: "relationshipWithStaff2",
        required: false,
      },
      {
        label: "Emergency Contact Name",
        type: "text",
        name: "emergencyContactName2",
        required: false,
      },
      {
        label: "Alternate Phone No",
        type: "number",
        name: "altPhoneNumber",
        required: false,
      },
      {
        label: "Education",
        type: "text",
        name: "education",
        required: false,
      }
    ];
  } catch (error) {
    console.error("Error fetching branch details fields:", error);
    return []; // Return empty array if there's an error
  }
};

export const initialAccountDetails = {
  customerUniqueId: null,
  accountNumber: null,
  accountType: null,
};

export const getAccountDetailsFields = async () => {
  try {
    const customerUniqueIds = await getCustomerUniqueIds();

    // Return dynamically populated fields
    return [
      {
        label: "Customer Unique Id",
        type: "select",
        name: "customerUniqueId",
        required: true,
        options: customerUniqueIds,
      },
      {
        label: "Account Number",
        type: "text",
        name: "accountNumber",
        required: true,
        readOnly: true,
      },
      {
        label: "Account Type",
        type: "select",
        name: "accountType",
        required: true,
        options: [
          { value: "01", label: "Savings Account" },
          { value: "02", label: "Fixed Deposit" },
          { value: "03", label: "Recurring Deposit" },
          { value: "04", label: "Loan Account" },
          { value: "05", label: "Chit Account" },
        ],
      },
    ];
  } catch (error) {
    console.error("Error fetching branch details fields:", error);
    return []; // Return empty array if there's an error
  }
};

export const initialDeposits = {
  transactionType: "deposit",
  accountType: null,
  accountNumber: null,
  customerUniqueId: null,
  amount: null,
  narration: null,
  date: new Date().toISOString().split("T")[0],
  debitCredit: "credit",
};

const getcustomerdetails = async () => { };

export const getDepositsFields = async (accountType1) => {
  try {
    let accountNumbers = [];
    if (accountType1) {
      accountNumbers = await getAccountNumbers(accountType1);
    }
    const customerdetails = await getcustomerdetails();
    // Return dynamically populated fields
    return [
      {
        label: "Account Type",
        type: "select",
        name: "accountType",
        required: true,
        options: [
          { value: "01", label: "Savings Account" },
          { value: "02", label: "Fixed Deposit" },
          { value: "03", label: "Recurring Deposit" },
          { value: "04", label: "Loan Account" },
          { value: "05", label: "Chit Account" },
        ],
      },
      {
        label: "Account Number",
        type: "select",
        name: "accountNumber",
        required: true,
        options: accountNumbers,
      },
      {
        label: "Customer Unique Id",
        type: "text",
        name: "customerUniqueId",
        required: true,
        readOnly: true,
      },
      {
        label: "Amount",
        type: "number",
        name: "amount",
        required: true,
      },
      {
        label: "Narration",
        type: "textarea",
        name: "narration",
        required: true,
      },
      {
        label: "Date",
        type: "date",
        name: "date",
        required: true,
        readOnly: true,
      },
    ];
  } catch (error) {
    console.error("Error fetching deposit fields:", error);
    return []; // Return empty array if there's an error
  }
};

export const initialWithDrawals = {
  transactionType: "withdraw",
  accountType: null,
  accountNumber: null,
  customerUniqueId: null,
  amount: null,
  narration: null,
  date: new Date().toISOString().split("T")[0],
  debitCredit: "debit",
};

export const getWithdrawalFields = async (accountType1) => {
  try {
    const accountNumbers = await getAccountNumbers(accountType1);
    const customerdetails = await getcustomerdetails();
    // Return dynamically populated fields
    return [
      {
        label: "Account Type",
        type: "select",
        name: "accountType",
        required: true,
        options: [
          { value: "01", label: "Savings Account" },
          { value: "02", label: "Fixed Deposit" },
          { value: "03", label: "Recurring Deposit" },
          { value: "04", label: "Loan Account" },
          { value: "05", label: "Chit Account" },
        ],
      },
      {
        label: "Account Number",
        type: "select",
        name: "accountNumber",
        required: true,
        options: accountNumbers,
      },
      {
        label: "Customer Unique Id",
        type: "text",
        name: "customerUniqueId",
        required: true,
        readOnly: true,
      },
      {
        label: "Amount",
        type: "number",
        name: "amount",
        required: true,
      },
      {
        label: "Narration",
        type: "textarea",
        name: "narration",
        required: true,
      },
      {
        label: "Date",
        type: "date",
        name: "date",
        required: true,
        readOnly: true,
      },
    ];
  } catch (error) {
    console.error("Error fetching withdrawal fields:", error);
    return []; // Return empty array if there's an error
  }
};

export const initialMemberDetails = {
  ApplicationId: null,
  customerId: null,
  residenceType: null,
  stayingStabilityInYears: 0,
  stayingStabilityInMonths: 0,
  ebNumber: 0,
  familyCardNo: 0,
  rationShopNo: 0,
  dataEntryOperatorStatus: "pending",
  dataEntryOperatorMessage: null,
  dataEntryOperatorStatusUpdatedAt: null,
  branchManagerStatus: "pending",
  branchManagerMessage: null,
  branchManagerStatusUpdatedAt: null,
  adminStatus: "pending",
  adminMessage: null,
  adminStatusUpdatedAt: null,
  loanId: null,
  processingCharge: 0,
  isProcessingChargePaid: null,
  gst: 0,
  isGstPaid: null,
  securityDeposit: 0,
  isSecurityDepositPaid: null,
  isLoanInsured: null,
  insuranceAmount: 0,
  isInsuranceAmountPaid: null,
  amountToRelease: 0,
  loanType: "Business Loan",
};

export const memberDetailsFields = async () => {
  try {
    const customerOptions = await getCustomerOptions();
    return [
      {
        label: "Application Id",
        type: "text",
        name: "ApplicationId",
        readOnly: true,
      },
      {
        label: "Residence Type",
        type: "select",
        name: "residenceType",
        required: true,
        options: [
          { value: "Own", label: "Own" },
          { value: "Rental", label: "Rental" },
          { value: "Leased", label: "Leased" },
        ],
      },
      {
        label: "Staying Stability in Years",
        type: "number",
        name: "stayingStabilityInYears",
        required: true,
      },
      {
        label: "Staying Stability in Months",
        type: "number",
        name: "stayingStabilityInMonths",
        required: true,
      },
      {
        label: "EB Number",
        type: "text",
        name: "ebNumber",
      },
      {
        label: "Family Card Number",
        type: "text",
        name: "familyCardNo",
      },
      {
        label: "Rationshop Number",
        type: "text",
        name: "rationShopNo",
      },
      // {
      //   label: "Data Entry Operator Status",
      //   type: "text",
      //   name: "dataEntryOperatorStatus",
      //   readOnly: true,
      // },
      // {
      //   label: "Data Entry Operator Message",
      //   type: "text",
      //   name: "dataEntryOperatorMessage",
      //   readOnly: true,
      // },
      // {
      //   label: "Data Entry Operator Status Updated At",
      //   type: "text",
      //   name: "dataEntryOperatorStatusUpdatedAt",
      //   readOnly: true,
      // },
      // {
      //   label: "Branch Manager Status",
      //   type: "text",
      //   name: "branchManagerStatus",
      //   readOnly: true,
      // },
      // {
      //   label: "Branch Manager Message",
      //   type: "text",
      //   name: "branchManagerMessage",
      //   readOnly: true,
      // },
      // {
      //   label: "Branch Manager Status Updated At",
      //   type: "text",
      //   name: "branchManagerStatusUpdatedAt",
      //   readOnly: true,
      // },
      // {
      //   label: "Admin Status",
      //   type: "text",
      //   name: "adminStatus",
      //   readOnly: true,
      // },
      // {
      //   label: "Admin Message",
      //   type: "text",
      //   name: "adminMessage",
      //   readOnly: true,
      // },
      // {
      //   label: "Admin Status Updated At",
      //   type: "text",
      //   name: "adminStatusUpdatedAt",
      //   readOnly: true,
      // },
      {
        label: "Loan Id",
        type: "text",
        name: "loanId",
        readOnly: true,
      },
      {
        label: "Processing Charge",
        type: "text",
        name: "processingCharge",
        readOnly: true,
      },
      {
        label: "Is Processing Charge Paid",
        type: "checkbox",
        name: "isProcessingChargePaid",
        readOnly: true,

      },
      {
        label: "GST",
        type: "number",
        name: "gst",
        readOnly: true,
      },
      {
        label: "Is GST Paid",
        type: "checkbox",
        name: "isGstPaid",
        readOnly: true,
      },
      {
        label: "Security Deposit",
        type: "number",
        name: "securityDeposit",
        readOnly: true,
      },
      {
        label: "Is Security Deposit Paid",
        type: "checkbox",
        name: "isSecurityDepositPaid",
        readOnly: true,
      },
      {
        label: "Is Loan Insured",
        type: "checkbox",
        name: "isLoanInsured",
        readOnly: true,
      },
      {
        label: "Insurance Amount",
        type: "number",
        name: "insuranceAmount",
        readOnly: true,
      },
      {
        label: "Is Insurance Amount Paid",
        type: "checkbox",
        name: "isInsuranceAmountPaid",
        readOnly: true,
      },
      {
        label: "Amount to Release",
        type: "number",
        name: "amountToRelease",
        readOnly: true,
      },
      {
        label: "Loan Type",
        type: "number",
        name: "loanType",
        readOnly: true,
      },
    ];
  } catch (error) {
    console.error("Error fetching member details fields:", error);
    return [];
  }
};

export const memberPersonalDetailsFields = async (branchId = null) => {
  try {
    const fieldOfficerOptions = await getFieldOfficersOptions(branchId);
    return [
      {
        label: "Assigned to Field Officer",
        type: "select",
        name: "fieldOfficerId",
        options: fieldOfficerOptions,
        required: true,
      },
      {
        label: "Name",
        type: "text",
        name: "name",
        required: true,
      },
      {
        label: "Gender",
        type: "select",
        name: "gender",
        options: [
          { value: "Male", label: "Male" },
          { value: "Female", label: "Female" },
          { value: "Other", label: "Other" },
        ],
        required: true,
      },
      {
        label: "Date of Birth",
        type: "datepicker",
        name: "dob",
        required: true,
      },
      {
        label: "Age",
        type: "number",
        name: "age",
        readOnly: true,
        required: true,
      },
      {
        label: "Mobile Number",
        type: "number",
        name: "mobileNumber",
        required: true,
      },
      {
        label: "Alternate Mobile Number",
        type: "number",
        name: "altMobileNumber",
        required: false,
      },
      {
        label: "Marital Status",
        type: "select",
        name: "maritalStatus",
        options: [
          { value: "Married", label: "Married" },
          { value: "Unmarried", label: "Unmarried" },
          { value: "Others", label: "Others" },
        ],
        required: true,
      },
      {
        label: "Father's Name",
        type: "text",
        name: "fatherName",
        required: true,
      },
      {
        label: "Spouse's Name",
        type: "text",
        name: "spouseName",
        required: false,
      },
      {
        label: "Permanent Door Number",
        type: "text",
        name: "permanentDoorNo",
        required: true,
      },
      {
        label: "Permanent Street Address",
        type: "text",
        name: "permanentStreetAddress",
        required: true,
      },
      {
        label: "Permanent Village",
        type: "text",
        name: "permanentVillage",
        required: true,
      },
      {
        label: "Permanent City",
        type: "text",
        name: "permanentCity",
        required: true,
      },
      {
        label: "Permanent District",
        type: "text",
        name: "permanentDistrict",
        required: true,
      },
      {
        label: "Permanent State",
        type: "text",
        name: "permanentState",
        required: true,
      },
      {
        label: "Permanent Postal Code",
        type: "number",
        name: "permanentPostalCode",
        required: true,
      },
      {
        label: "Same as Permanent Address",
        type: "checkbox",
        name: "sameAsPermanentAddress",
        required: true,
      },
      {
        label: "Current Door Number",
        type: "text",
        name: "currentDoorNumber",
        required: true,
      },
      {
        label: "Current Street Address",
        type: "text",
        name: "currentStreetAddress",
        required: true,
      },
      {
        label: "Current Village",
        type: "text",
        name: "currentVillage",
        required: true,
      },
      {
        label: "Current City",
        type: "text",
        name: "currentCity",
        required: true,
      },
      {
        label: "Current State",
        type: "text",
        name: "currentState",
        required: true,
      },
      {
        label: "Current Postal Code",
        type: "number",
        name: "currentPostalCode",
        required: true,
      },
      {
        label: "Citizenship",
        type: "text",
        name: "citizenship",
        readOnly: true,
        required: true,
      },
      // Read-only here: both images belong to the CUSTOMER and are captured on
      // the Customers screen, which is now the only place that can accept them.
      //
      // `required` deliberately dropped. It used to sit beside readOnly:true,
      // which put a red asterisk on a field the operator was forbidden to fill —
      // and validationSchema said notRequired(), so it never blocked submit
      // either. The result was a permanent "No Document *" that demanded
      // something and refused to accept it.
      {
        label: "Customer Profile Image",
        type: "file",
        name: "customerProfileImage",
      },
      {
        label: "Customer Signature Image",
        type: "file",
        name: "customerSignatureImage",
      },
    ];
  } catch (error) {
    console.error("Error fetching personal details fields:", error);
    return [];
  }
};

export const memberVerificationDetailsFields = [
  {
    label: "Aadhar No",
    type: "number",
    name: "aadharNo",
    required: true,
  },
  {
    label: "Aadhar Front Image",
    type: "file",
    name: "aadharFrontImage",
    required: true,
  },
  {
    label: "Aadhar Back Image",
    type: "file",
    name: "aadharBackImage",
    required: true,
  },
  { label: "PAN No", type: "text", name: "panNo", required: true },
  {
    label: "ID Proof",
    type: "select",
    name: "idProof",
    options: [
      { value: "Voter", label: "Voter" },
      { value: "Driving Licence", label: "Driving Licence" },
      { value: "Ration", label: "Ration" },
      { value: "Passport", label: "Passport" },
      { value: "Aadhar", label: "Aadhar" },
      { value: "Pan", label: "PanCard" },

    ],
    placeholder: "Select ID Proof",
    required: true,
  },
  { label: "ID Proof No", type: "text", name: "idProofNo", required: true },
  {
    label: "ID Proof Front Image",
    type: "file",
    name: "idProofFrontImage",
    required: true,
  },
  {
    label: "ID Proof Back Image",
    type: "file",
    name: "idProofBackImage",
    required: true,
  },
  {
    label: "Address Proof",
    type: "select",
    name: "addressProof",
    options: [
      { value: "Electricity Bill", label: "Electricity Bill" },
      { value: "Gas Bill", label: "Gas Bill" },
      { value: "Smart Card", label: "Smart Card" },
      { value: "Aadhar", label: "Aadhar" },
    ],
    placeholder: "Select Address Proof",
    required: true,
  },
  {
    label: "Address Proof No",
    type: "text",
    name: "addressProofNo",
    required: true,
  },
  {
    label: "Address Proof Front Image",
    type: "file",
    name: "addressProofFrontImage",
    required: true,
  },
  {
    label: "Address Proof Back Image",
    type: "file",
    name: "addressProofBackImage",
    required: true,
  },
];

export const memberNomineeDetailsFields = [
  { label: "Name", type: "text", name: "name", required: true },
  { label: "Father Name", type: "text", name: "fatherName", required: true },
  {
    label: "Gender",
    type: "select",
    name: "gender",
    options: [
      { value: "Male", label: "Male" },
      { value: "Female", label: "Female" },
      { value: "other", label: "other" },
    ],
    placeholder: "Select Gender",
    required: true,
  },
  { label: "Date of Birth", type: "date", name: "dob", required: true },
  {
    label: "Mobile Number",
    type: "number",
    name: "mobileNumber",
    required: true,
  },
  {
    label: "Alt Mobile Number",
    type: "number",
    name: "altMobileNumber",
    required: false,
  },
  {
    label: "Relationship",
    type: "select",
    name: "relationship",
    options: [
      { value: "spouse", label: "spouse" },
      { value: "father", label: "father" },
      { value: "mother", label: "mother" },
      { value: "son", label: "son" },
      { value: "daughter", label: "daughter" },
      { value: "grand-mother", label: "grand-mother" },
      { value: "grand-father", label: "grand-father" },
      { value: "other", label: "other" },
    ],
    placeholder: "Select Relationship",
    required: true,
  },
  { label: "Address", type: "text", name: "address", required: true },
  { label: "Aadhar No", type: "text", name: "aadharNo", required: true },
  {
    label: "ID Proof",
    type: "select",
    name: "idProof",
    options: [
      { value: "Voter", label: "Voter" },
      { value: "Driving Licence", label: "Driving Licence" },
      { value: "Ration", label: "Ration" },
      { value: "Aadhar", label: "Aadhar" },
      { value: "Passport", label: "Passport" },
      { value: "Pan", label: "PanCard" },

    ],
    placeholder: "Select ID Proof",
    required: true,
  },
  { label: "ID Proof No", type: "text", name: "idProofNo", required: true },
  {
    label: "ID Proof Front Image",
    type: "file",
    name: "idProofFrontImage",
    required: true,
  },
  {
    label: "ID Proof Back Image",
    type: "file",
    name: "idProofBackImage",
    required: true,
  },
];

// Initialised BY TYPE — text empty, numbers and dates null, checkboxes false.
//
// Every key here used to be the number 0, including varchar columns like
// companyName and designation and the salaryDate picker. That put a literal "0"
// in every box before anything was typed, and an operator who skipped a field
// saved the string "0" as the company name — which then read as 0 on every
// report downstream rather than as blank.
//
// state and nationality are genuine defaults, not placeholders, so they stay.
export const initialMemberBusinessDetails = {
  name: "",
  occupationType: "",
  sourceOfIncome: null,
  relationshipType: "",
  designation: "",
  experienceInCurrentCompanyInYears: null,
  experienceInCurrentCompanyInMonths: null,
  companyName: "",
  companyAddress: "",
  overallExperienceInYears: null,
  overallExperienceInMonths: null,
  monthlySalary: null,
  salaryDate: null,
  shopName: "",
  shopAddress: "",
  shopLocation: "",
  businessTypeId: null,
  natureOfBusinessId: null,
  stabilityInBusinessInYears: null,
  stabilityInBusinessInMonths: null,
  yearsOfStabilityInCurrentAddress: null,
  monthlyBusinessIncome: null,
  isGstRegistered: false,
  gstNumber: "",
  isUdhayamRegistered: false,
  udhayamNumber: "",
  district: "",
  state: "Tamilnadu",
  nationality: "Indian",
  overallBusinessExperience: null,
  jobDescription: "",
  dailyIncome: null,
};

export const memberBusinessDetailsFields = async (businessCategoryId1) => {
  try {
    const businessCategories = await getBusinessCategoriesOptions();

    let natureOfBusiness = [];
    if (businessCategoryId1) {
      natureOfBusiness = await getNatureOfBusinessOptions(businessCategoryId1);
    }
    return [
      // alphaOnly is set only where a value genuinely cannot contain digits.
      // Shop Name ("A1 Traders"), Shop Address ("12/A Main Road"), GST Number,
      // Udhayam Number and Job Description are deliberately left unrestricted.
      // Prefilled from the customer in AddEditBusinessLoan.jsx and locked: the
      // business record belongs to the customer, so the two must not be able to
      // disagree. alphaOnly is kept so the rule still applies if it is unlocked.
      { label: "Name", type: "text", name: "name", required: true, alphaOnly: true, readOnly: true },
      // Decides which half of this form applies. Asked directly after Name so
      // it is answered before anything that depends on it. Fields tagged
      // occupation: "Employee" or "Business" show only for the matching answer;
      // untagged fields always show.
      {
        label: "Occupation Type",
        type: "select",
        name: "occupationType",
        options: [
          { value: "Employee", label: "Employee" },
          { value: "Business", label: "Business" },
        ],
        required: true,
      },
      {
        label: "Source of Income",
        type: "number",
        name: "sourceOfIncome",
        required: false,
      },
      // {
      //   label: "Relationship Type",
      //   type: "text",
      //   name: "relationshipType",
      //   required: true,
      // },
      {
        label: "Designation",
        type: "text",
        name: "designation",
        required: false,
        occupation: "Employee",
        alphaOnly: true,
      },
      {
        label: "Experience in Current Company in Years",
        type: "number",
        name: "experienceInCurrentCompanyInYears",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Experience in Current Company in Months",
        type: "number",
        name: "experienceInCurrentCompanyInMonths",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Company Name",
        type: "text",
        name: "companyName",
        required: false,
        occupation: "Employee",
        alphaOnly: true,
      },
      {
        label: "Company Address",
        type: "text",
        name: "companyAddress",
        required: false,
        occupation: "Employee",
        alphaOnly: true,
      },
      {
        label: "Overall Experience in Years",
        type: "number",
        name: "overallExperienceInYears",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Overall Experience in Months",
        type: "number",
        name: "overallExperienceInMonths",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Monthly Salary",
        type: "number",
        name: "monthlySalary",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Salary Date",
        type: "date",
        name: "salaryDate",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Shop Name",
        type: "text",
        name: "shopName",
        required: false,
        occupation: "Business",
      },
      {
        label: "Shop Address",
        type: "text",
        name: "shopAddress",
        required: false,
        occupation: "Business",
      },
      {
        label: "Shop Location",
        type: "text",
        name: "shopLocation",
        required: false,
        occupation: "Business",
        alphaOnly: true,
      },
      {
        label: "Business Category",
        type: "select",
        name: "businessCategoryId",
        options: businessCategories,
        required: false,
        occupation: "Business",
      },
      {
        label: "Nature of Business",
        type: "select",
        name: "natureOfBusinessId",
        options: natureOfBusiness,
        required: false,
        occupation: "Business",
      },
      {
        label: "Stability in Business in Years",
        type: "number",
        name: "stabilityInBusinessInYears",
        required: false,
        occupation: "Business",
      },
      {
        label: "Stability in Business in Months",
        type: "number",
        name: "stabilityInBusinessInMonths",
        required: false,
        occupation: "Business",
      },
      {
        label: "Years of Stability in Current Address",
        type: "number",
        name: "yearsOfStabilityInCurrentAddress",
        required: false,
        occupation: "Business",
      },
      {
        label: "Monthy Business Income",
        type: "number",
        name: "monthlyBusinessIncome",
        required: false,
        occupation: "Business",
      },
      {
        label: "Is GST Registered",
        type: "checkbox",
        name: "isGstRegistered",
        required: false,
        occupation: "Business",
      },
      {
        label: "GST Number",
        type: "text",
        name: "gstNumber",
        required: false,
        occupation: "Business",
      },
      {
        label: "Is Udhayam Registered",
        type: "checkbox",
        name: "isUdhayamRegistered",
        required: false,
        occupation: "Business",
      },
      {
        label: "Udhayam Number",
        type: "text",
        name: "udhayamNumber",
        required: false,
        occupation: "Business",
      },
      {
        label: "District",
        type: "text",
        name: "district",
        required: false,
        alphaOnly: true,
      },
      {
        label: "State",
        type: "text",
        name: "state",
        required: false,
        alphaOnly: true,
      },
      {
        label: "Nationality",
        type: "text",
        name: "nationality",
        required: false,
        alphaOnly: true,
      },
      {
        label: "Overall Business Experience",
        type: "number",
        name: "overallBusinessExperience",
        required: false,
      },
      {
        label: "Job Description",
        type: "text",
        name: "jobDescription",
        required: false,
      },
      {
        label: "Daily Income",
        // number, not text: the column is int(11) and holds only numbers, so a
        // text input here was a mismatch with its own storage.
        type: "number",
        name: "dailyIncome",
        required: false,
      },
    ];
  } catch (error) {
    console.error("Error fetching memberBusinessDetailsFields:", error);
    return [];
  }
};

// Initialised BY TYPE, matching initialMemberBusinessDetails.
//
// This object was a mix of null and 0, with 0 on text fields like gstNumber and
// udhayamNumber — the same fault the member object had, which put a literal "0"
// in the box and saved the string "0" into varchar columns when the field was
// skipped.
//
// state and nationality are genuine defaults, not placeholders, so they stay.
export const initialNomineeBusinessDetails = {
  name: "",
  occupationType: "",
  sourceOfIncome: null,
  relationshipType: "",
  designation: "",
  experienceInCurrentCompanyInYears: null,
  experienceInCurrentCompanyInMonths: null,
  companyName: "",
  companyAddress: "",
  overallExperienceInYears: null,
  overallExperienceInMonths: null,
  monthlySalary: null,
  salaryDate: null,
  shopName: "",
  shopAddress: "",
  shopLocation: "",
  businessTypeId: null,
  natureOfBusinessId: null,
  stabilityInBusinessInYears: null,
  stabilityInBusinessInMonths: null,
  yearsOfStabilityInCurrentAddress: null,
  monthlyBusinessIncome: null,
  isGstRegistered: false,
  gstNumber: "",
  isUdhayamRegistered: false,
  udhayamNumber: "",
  district: "",
  state: "Tamilnadu",
  nationality: "Indian",
  overallBusinessExperience: null,
  jobDescription: "",
  dailyIncome: null,
};

export const nomineeBusinessDetailsFields = async (businessCategoryId1) => {
  try {
    const businessCategories = await getBusinessCategoriesOptions();

    let natureOfBusiness = [];
    if (businessCategoryId1) {
      natureOfBusiness = await getNatureOfBusinessOptions(businessCategoryId1);
    }
    return [
      // Prefilled from the nominee and locked, mirroring the member tab.
      // alphaOnly set only where digits are impossible; Shop Name, Shop Address,
      // GST Number, Udhayam Number and Job Description stay unrestricted.
      { label: "Name", type: "text", name: "name", required: true, alphaOnly: true, readOnly: true },
      // Decides which half of this form applies. Asked directly after Name so
      // it is answered before anything that depends on it. Fields tagged
      // occupation: "Employee" or "Business" show only for the matching answer;
      // untagged fields always show.
      {
        label: "Occupation Type",
        type: "select",
        name: "occupationType",
        options: [
          { value: "Employee", label: "Employee" },
          { value: "Business", label: "Business" },
        ],
        required: true,
      },
      {
        label: "Source of Income",
        type: "number",
        name: "sourceOfIncome",
        required: false,
      },
      {
        label: "Relationship Type",
        type: "text",
        name: "relationshipType",
        required: false,
      },
      {
        label: "Designation",
        type: "text",
        name: "designation",
        required: false,
        occupation: "Employee",
        alphaOnly: true,
      },
      {
        label: "Experience in Current Company in Years",
        type: "number",
        name: "experienceInCurrentCompanyInYears",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Experience in Current Company in Months",
        type: "number",
        name: "experienceInCurrentCompanyInMonths",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Company Name",
        type: "text",
        name: "companyName",
        required: false,
        occupation: "Employee",
        alphaOnly: true,
      },
      {
        label: "Company Address",
        type: "text",
        name: "companyAddress",
        required: false,
        occupation: "Employee",
        alphaOnly: true,
      },
      {
        label: "Overall Experience in Years",
        type: "number",
        name: "overallExperienceInYears",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Overall Experience in Months",
        type: "number",
        name: "overallExperienceInMonths",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Monthly Salary",
        type: "number",
        name: "monthlySalary",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Salary Date",
        type: "date",
        name: "salaryDate",
        required: false,
        occupation: "Employee",
      },
      {
        label: "Shop Name",
        type: "text",
        name: "shopName",
        required: false,
        occupation: "Business",
      },
      {
        label: "Shop Address",
        type: "text",
        name: "shopAddress",
        required: false,
        occupation: "Business",
      },
      {
        label: "Shop Location",
        type: "text",
        name: "shopLocation",
        required: false,
        occupation: "Business",
        alphaOnly: true,
      },
      {
        label: "Business Category",
        type: "select",
        name: "businessCategoryId",
        options: businessCategories,
        required: false,
        occupation: "Business",
      },
      {
        label: "Nature of Business",
        type: "select",
        name: "natureOfBusinessId",
        options: natureOfBusiness,
        required: false,
        occupation: "Business",
      },
      {
        label: "Stability in Business in Years",
        type: "number",
        name: "stabilityInBusinessInYears",
        required: false,
        occupation: "Business",
      },
      {
        label: "Stability in Business in Months",
        type: "number",
        name: "stabilityInBusinessInMonths",
        required: false,
        occupation: "Business",
      },
      {
        label: "Years of Stability in Current Address",
        type: "number",
        name: "yearsOfStabilityInCurrentAddress",
        required: false,
        occupation: "Business",
      },
      {
        label: "Monthy Business Income",
        type: "number",
        name: "monthlyBusinessIncome",
        required: false,
        occupation: "Business",
      },
      {
        label: "Is GST Registered",
        type: "checkbox",
        name: "isGstRegistered",
        required: false,
        occupation: "Business",
      },
      {
        label: "GST Number",
        type: "text",
        name: "gstNumber",
        required: false,
        occupation: "Business",
      },
      {
        label: "Is Udhayam Registered",
        type: "checkbox",
        name: "isUdhayamRegistered",
        required: false,
        occupation: "Business",
      },
      {
        label: "Udhayam Number",
        type: "text",
        name: "udhayamNumber",
        required: false,
        occupation: "Business",
      },
      {
        label: "District",
        type: "text",
        name: "district",
        required: false,
        alphaOnly: true,
      },
      {
        label: "State",
        type: "text",
        name: "state",
        required: false,
        alphaOnly: true,
      },
      {
        label: "Nationality",
        type: "text",
        name: "nationality",
        required: false,
        alphaOnly: true,
      },
      {
        label: "Overall Business Experience",
        type: "number",
        name: "overallBusinessExperience",
        required: false,
      },
      {
        label: "Job Description",
        type: "text",
        name: "jobDescription",
        required: false,
      },
      {
        label: "Daily Income",
        type: "number",
        name: "dailyIncome",
        required: false,
      },
    ];
  } catch (error) {
    console.error("Error fetching memberBusinessDetailsFields:", error);
    return [];
  }
};

export const initialLoanDetails = {

  currentNoOfLoans: null,
  loanCompanyNames: null,
  totalmonthlyEmi: null,
};

export const loanDetailsFields = [

  {
    label: "Current No of Loans",
    type: "number",
    name: "currentNoOfLoans",
    required: false,
  },
  {
    label: "Loan Company Names",
    type: "text",
    name: "loanCompanyNames",
    required: false,
  },
  {
    label: "Total Monthly EMI",
    type: "number",
    name: "totalmonthlyEmi",
    required: false,
  },
];

export const initialProposedLoanDetails = {
  applicantName: null,
  coApplicant1: null,
  emiDate: null,
  loanAmount: null,
  rateOfInterest: null,
  tenureInMonths: null,
  monthlyEmi: null,
  houseHoldExpenses: null,
  otherExpenses: null,
  fundingAgencyId: null,
  fundingAmount1: null,
  fundingAmount2: null,
  fundingAgencyId2: null,
  fundingAmount3: null,
  fundingAgencyId3: null,
  processingFee: null,
  gstOnProcessingFee: null,
  totalAmountPayable: null,
};

export const proposedLoanDetailsFields = async () => {
  try {
    const fundingAgencies = await getFundingAgencies();
    return [
      {
        label: "Applicant Name",
        type: "text",
        name: "applicantName",
        required: true,
      },
      {
        label: "CoApplicant",
        type: "text",
        name: "coApplicant1",
        required: true,
      },
      {
        label: "Loan Date (DD.MM.YYYY)",
        type: "text",
        name: "emiDate",
        required: true,
      },
      {
        label: "Loan Amount",
        type: "number",
        name: "loanAmount",
        required: true,
      },
      {
        label: "Interest Rate",
        type: "select",
        name: "rateOfInterest",
        // Only the two rates the FPO actually lends on. The rest are commented
        // out rather than deleted so they can be restored by uncommenting if the
        // business offers them again.
        //
        // Safe to hide: no loan uses any of the three (verified against
        // proposed_loan_details — only REGULAR and 1.41 appear). Re-check before
        // a live deploy; a rate still held by a saved loan must stay listed, or
        // that loan cannot be opened for edit without changing its rate.
        //
        // calculateEmi (pages/Loans/ProposedLoanDetails.js) deliberately still
        // knows all five, so uncommenting a line here is the whole restore.
        options: [
          { value: "1.41", label: "1.41" },
          { value: "REGULAR", label: "REGULAR" },
          // { value: "1.61", label: "1.61" },
          // { value: "24", label: "24" },
          // { value: "22", label: "22" },
        ],
        required: true,
      },
      {
        label: "Tenure in Months",
        type: "number",
        name: "tenureInMonths",
        required: true,
      },
      // {
      //   label: "Monthly EMI",
      //   type: "number",
      //   name: "monthlyEmi",
      //   required: true,
      //   readOnly: true,
      // },
      // {
      //   label: "Household Expenses",
      //   type: "number",
      //   name: "houseHoldExpenses",
      //   required: true,
      // },
      // {
      //   label: "Other Expenses",
      //   type: "number",
      //   name: "otherExpenses",
      //   required: true,
      // },
      {
        label: "Funding Agency",
        type: "select",
        name: "fundingAgencyId",
        options: fundingAgencies,
        required: false,
      },
      {
        label: "Own Fund",
        type: "number",
        name: "fundingAmount2",
        required: true,
      },
      {
        label: "Funding Agency",
        type: "select",
        name: "fundingAgencyId2",
        options: fundingAgencies,
        required: false,
      },
      {
        label: "Federal Fund",
        type: "number",
        name: "fundingAmount1",
        required: true,
      },
      {
        label: "Funding Agency",
        type: "select",
        name: "fundingAgencyId3",
        options: fundingAgencies,
        required: false,
      },
      {
        label: "Other Fund",
        type: "number",
        name: "fundingAmount3",
        required: true,
      },
      {
        label: "Processing Fee",
        type: "number",
        name: "processingFee",
        readOnly: false,
      },
      {
        label: "GST on Processing Fee ",
        type: "number",
        name: "gstOnProcessingFee",
        readOnly: false,
      },
      {
        label: "Total Amount",
        type: "text",
        name: "totalAmountPayable",
        readOnly: false,
      },
    ];
  } catch (error) {
    console.error("Error fetching proposedLoanDetails:", error);
    return [];
  }
};

export const memberBankDetailsFields = [
  {
    label: "Account Number",
    type: "number",
    name: "accountNumber",
    required: true,
  },
  {
    label: "Account Holder Name",
    type: "text",
    name: "accountHolderName",
    required: true,
  },
  { label: "IFSC Code", type: "text", name: "ifscCode", required: true },
  { label: "Bank Name", type: "text", name: "bankName", required: true },
  {
    label: "Bank Branch Name",
    type: "text",
    name: "bankBranchName",
    required: true,
  },
  { label: "Account Type", type: "text", name: "accountType", required: true },
];

export const initialFundingAgencyDetails = {
  agencyName: null,
};

export const fundingAgencyFields = [
  { label: "Agency Name", type: "text", name: "agencyName", required: true },
];
